import { render, staticRenderFns } from "./input-resolution.vue?vue&type=template&id=45298eb4&"
import script from "./input-resolution.vue?vue&type=script&lang=js&"
export * from "./input-resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports